module.exports = __webpack_public_path__ + "img/hr-tree-06-f-leaves.646fde2e.png";